import React, { useState } from 'react';

import Form from './form.component';

import { endTimeoutWithAnimation } from '@Components/notification/notification.config';

import { FormContainerProps } from './form.definition';

export const FormContainer = (props: FormContainerProps) => {
	const {
		onSubmit
	} = props;

	const [hasError, setHasError] = useState(false);

	const handleSubmit = (e: any) => {
		e.preventDefault();

		setHasError(false);

		// validation
		const form = (e.target);
		const requiredFields = form?.querySelectorAll('[data-validation]');
		let isValid = true;

		requiredFields.length > 0 && requiredFields.forEach((field: HTMLBaseElement) => {
			const activeError = field.querySelector('.error-text--isactive');

			const isInputValid = handleValidation(field);

			if (activeError !== null || !isInputValid) {
				isValid = false;
			}
		});

		if (isValid) {
			onSubmit();
		} else {
			setHasError(true);

			setTimeout(() => {
				setHasError(false);
			}, endTimeoutWithAnimation);
		}
	};

	const handleValidation = (elem: HTMLBaseElement) => {
		const required = elem.getAttribute('data-validation');
		const pattern = elem.getAttribute('data-pattern');
		const { value }: HTMLInputElement | HTMLTextAreaElement = elem.querySelector('input, textarea');

		// if is don't have a required field and value is empty then return valid
		if (required === 'false') {
			if (value === '') {
				return true;
			}
		}

		if (pattern) {
			const isValid = value.match(pattern);

			if (isValid !== null) {
				return true;
			} else {
				elem.querySelector('.error-text').classList.add('error-text--isactive');

				return false;
			}
		}

		return true;
	};

	const containerProps = () => {
		return {
			...props,
			hasError
		};
	};

	const containerFunctions = {
		handleSubmit: handleSubmit.bind(this)
	};

	return (
		<Form
			{ ...containerProps() }
			{ ...containerFunctions }
		/>
	);
};

export default FormContainer;